export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('batch_label_orderBatchNo') || '交货批次号',
    field: 'orderBatchNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('batch_label_identifyNo') || '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('batch_label_deliveryDate') || '出货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  // {
  //   title: that.$l('batch_label_deliveryType') || '出货方式',
  //   field: 'deliveryType',
  //   headerAlign: 'center',
  //   align: 'center',
  //   minWidth: 120,
  //   showHeaderOverflow: true,
  //   showOverflow: true
  // },
  {
    title: that.$l('batch_label_outBillType') || '出单类型',
    field: 'outBillType',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('batch_label_dispatchPort') || '发运港口',
    field: 'dispatchPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('batch_label_destinationPort') || '目的港口',
    field: 'destinationPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true
  },
  // {
  //   title: that.$l('batch_label_receiver') || '收货人',
  //   field: 'receiver',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 120,
  //   showHeaderOverflow: true,
  //   showOverflow: true
  // },
  // {
  //   title: that.$l('batch_label_receiverPhone') || '联系电话',
  //   field: 'receiverPhone',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 140,
  //   showHeaderOverflow: true,
  //   showOverflow: true
  // },
  // {
  //   title: that.$l('batch_label_receiverAddress') || '收货地址',
  //   field: 'receiverAddress',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 200,
  //   showHeaderOverflow: true,
  //   showOverflow: true
  // }
]
